export default __webpack_public_path__ + "static/media/medium-inactive.62add292.svg";